import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    CircularProgress,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import axios_instance from '../../../services/auth/jwt/config';

interface DialogExportOrdemProps {
    open: boolean;
    tecnicos: { id: number; nome: string }[];
    onClose: () => void;
    tecnico?: string; // Label for the technician filter
    pdfUrl?: string; // URL template like "/api/relatorio?startDate={start}&endDate={end}"
}

export default function DialogExportOrdem({
    open,
    onClose,
    tecnicos,
    tecnico = 'Técnico',
    ...props
}: DialogExportOrdemProps) {
    const [startDate, setStartDate] = useState(moment().subtract(1, 'year').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [filterAtendente, setFilterAtendente] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleDownload = () => {
        setError(null);
        setLoading(true);

        // Validate dates
        if (!startDate || !endDate) {
            setError('Por favor, selecione ambas as datas');
            setLoading(false);
            return;
        }

        if (startDate > endDate) {
            setError('A data de início não pode ser maior que a data de fim');
            setLoading(false);
            return;
        }

        // Make request to download PDF
        axios_instance.get<any>(`/obra/ordem_servico/relatorio/tecnico`, {
            params: {
                start: startDate,
                end: endDate,
                tecnico: filterAtendente,
            },
            responseType: 'blob',
        }).then((r) => {

            // Create blob and download
            let a = document.createElement('a');
            a.href = URL.createObjectURL(r.data);
            a.download = `ordem-${startDate}-${endDate}.pdf`;
            a.click();

            onClose();
        }).catch((err) => {
        }).finally(() => {
            setLoading(false);
        })
    };

    const handleClose = () => {
        if (!loading) {
            setStartDate(moment().subtract(1, 'year').format('YYYY-MM-DD'));
            setEndDate(moment().format('YYYY-MM-DD'));
            setError(null);
            onClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>Exportar Ordem</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <KeyboardDatePicker
                            label="Data de Início"
                            format="DD/MM/YYYY"
                            disableFuture
                            value={moment(startDate).toDate()}
                            onChange={(e) => setStartDate(moment(e).format('YYYY-MM-DD'))}
                            disabled={loading}
                            inputVariant='outlined'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <KeyboardDatePicker
                            label="Data de Fim"
                            format="DD/MM/YYYY"
                            disableFuture
                            value={moment(endDate).toDate()}
                            onChange={(e) => setEndDate(moment(e).format('YYYY-MM-DD'))}
                            disabled={loading}
                            inputVariant='outlined'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl variant="outlined" fullWidth >
                            <InputLabel>{tecnico}</InputLabel>
                            <Select
                                value={filterAtendente}
                                onChange={(e) => {
                                    //@ts-ignore
                                    setFilterAtendente(e.target.value)
                                }}
                                label={tecnico}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {tecnicos.map((t, index) => (
                                    <MenuItem key={index} value={t.id}>{t.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    disabled={loading}
                    color="default"
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleDownload}
                    disabled={loading || !startDate || !endDate}
                    color="primary"
                    variant="contained"
                >
                    {loading && <CircularProgress size={20} />}
                    {loading ? 'Baixando...' : 'Baixar PDF'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}